<template>
	<div>
		<div
			class="relativeclass"
			:class="[
				selTest == testDetails.testID ||
				(testConfigData.testID == testDetails.testID &&
					(testConfigStatus || showTestPreviewStatus))
					? 'changecolor'
					: 'ts-cardv-main',
				testDetails.active ? 'pointer' : '',
			]"
			style="height: 245px;"
			@click="testDetails.active ? goToQPBuilder() : ''"
		>
			<div
				class="position-absolute tc-lb-badge d-flex align-items-center"
				v-if="leaderboardAdminAccess && testDetails.leaderboard"
			>
				<img src="@/assets/newimgs/leaderboard.svg" alt="" />
				<span class="font-mont fw-500 fs-12 color-white ml-1"
					>Featured in Leaderboard</span
				>
			</div>
			<div class="tp-cardhead">
				<div style="width: 50%">
					<div class="tp-text d-flex align-items-center position-relative">
						<span v-if="testDetails.active" class="ml-2"
							><img src="../../../assets/active.svg" alt="" class="mb-1"
						/></span>
						<span v-else class=""
							><img src="../../../assets/inactive.svg" alt="" class="mb-1"
						/></span>
						<span
							class="d-inline-block text-truncate ml-1"
							v-b-popover.hover.top="testDetails.name"
							style="max-width: 100%"
						>
							{{ testDetails.name }}
						</span>
					</div>

					<div
						class="tp-cardoptions d-flex justify-content-end align-items-center"
						v-if="!testDetails.active"
						@click.stop=""
					>
						<template v-if="leaderboardAdminAccess">
							<img
								v-if="testDetails.publicAvailability"
								v-b-popover.hover.top="'Public'"
								src="../../../assets/Testunlockgreen.svg"
								alt=""
								class="m-1 pointer"
								@click.stop="publicAvailabilityModal = true"
							/>
							<img
								v-else
								v-b-popover.hover.top="'Private'"
								src="../../../assets/Testlockred.svg"
								alt=""
								class="m-1 pointer"
								@click.stop="publicAvailabilityModal = true"
							/>
						</template>
						<img
							v-if="
								(!showTestPreviewStatus ||
									testConfigData.testID != testDetails.testID) &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click.stop="(showPreviewTest = true), saveTestPreview()"
							v-b-popover.hover.top="'Test Preview'"
							src="../../../assets/preview eye.svg"
							alt=""
							class="pointer"
							style="margin-right: 5px; margin-left: 4px"
						/>
						<img
							v-else-if="
								showTestPreviewStatus &&
									testConfigData.testID == testDetails.testID &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click="(showPreviewTest = false), saveTestPreview()"
							v-b-popover.hover.top="'Close Preview'"
							src="../../../assets/visibility_off.svg"
							alt=""
							class="pointer"
							style="margin-right: 5px; margin-left: 4px"
						/>
						<div
							v-if="roles.includes('ACTIVATE_TEST')"
							class="pointer"
							@click="testModal = !testModal"
							v-b-popover.hover.top="'Activate'"
						>
							<img src="../../../assets/ActiveroundTickPlus_1.svg" alt="" />
						</div>
					</div>
				</div>
				<div v-if="testDetails.active" @click.stop="">
					<div class="tp-cardoptions" v-if="!testDetails.editoption">
						<img
							v-if="testDetails.isLocked"
							@click.stop="locktestModal = !locktestModal"
							v-b-popover.hover.top="'Unlock'"
							src="../../../assets/lockicoinactive.svg"
							alt=""
							class="m-1"
						/>
						<img
							v-else
							@click.stop="locktestModal = !locktestModal"
							v-b-popover.hover.top="'Lock'"
							src="../../../assets/lockiconactive.svg"
							alt=""
							class="m-1"
						/>
						<template v-if="leaderboardAdminAccess">
							<img
								v-if="testDetails.publicAvailability"
								v-b-popover.hover.top="'Public'"
								src="../../../assets/Testunlockgreen.svg"
								alt=""
								class="m-1 pointer"
								@click.stop="publicAvailabilityModal = true"
							/>
							<img
								v-else
								v-b-popover.hover.top="'Private'"
								src="../../../assets/Testlockred.svg"
								alt=""
								class="m-1 pointer"
								@click.stop="publicAvailabilityModal = true"
							/>
						</template>
						<img
							v-if="roles.includes('GET_CONFIG')"
							src="../../../assets/icons/testconfigicon.svg"
							v-b-popover.hover.top="'Configuration'"
							@click.stop="saveTestConfig(testDetails)"
							alt=""
							class="m-1"
						/>

						<img
							v-if="
								(!showTestPreviewStatus ||
									testConfigData.testID != testDetails.testID) &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click.stop="(showPreviewTest = true), saveTestPreview()"
							v-b-popover.hover.top="'Test Preview'"
							src="../../../assets/preview eye.svg"
							alt=""
							class="m-1"
						/>
						<img
							v-else-if="
								showTestPreviewStatus &&
									testConfigData.testID == testDetails.testID &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click.stop="(showPreviewTest = false), saveTestPreview()"
							v-b-popover.hover.top="'Close Preview'"
							src="../../../assets/visibility_off.svg"
							alt=""
							class="m-1"
						/>

						<img
							v-if="
								roles.includes('PUT_TEST') ||
									roles.includes('DELETE_TEST') ||
									roles.includes('GET_TEST_INDIVIDUAL') ||
									roles.includes('GET_TEST_GROUP') ||
									roles.includes('CLONE_TEST')
							"
							src="../../../assets/ellipseicon.svg"
							alt=""
							class="m-1"
							v-b-popover.hover.top="'View More'"
							@click.stop="$emit('test-card-option', testDetails.testID)"
						/>
					</div>
					<transition name="slide-fade">
						<div
							class="tp-cardeditoptions pointer"
							v-if="testDetails.editoption"
						>
							<b-popover
								:target="testDetails.testID"
								:placement="'top'"
								triggers="hover focus"
							>
								<span v-if="testDetails.allSectionsHaveQuestions == true">
									Share
								</span>
								<span v-else-if="testDetails.numberOfSections == 0"
									>Add sections to the test</span
								>
								<span v-else-if="testDetails.allSectionsHaveQuestions == false"
									>&nbsp;All sections do not contain questions.</span
								>
							</b-popover>
							<img
								v-if="roles.includes('CLONE_TEST')"
								v-b-popover.hover.top="'Clone Test'"
								@click.stop="
									!testDetails.isLocked
										? ((cloneTestModal = !cloneTestModal), copyingVal())
										: null
								"
								src="../../../assets/clonetest.svg"
								alt=""
								class="m-1"
								:class="testDetails.isLocked ? 'disableSharing' : ''"
							/>
							<img
								v-if="
									roles.includes('GET_TEST_INDIVIDUAL') ||
										roles.includes('GET_TEST_GROUP')
								"
								:id="testDetails.testID"
								src="../../../assets/singleusericon.svg"
								@click.stop="
									testDetails.allSectionsHaveQuestions == false
										? ''
										: goToShare()
								"
								alt=""
								class="m-1"
								:class="
									testDetails.allSectionsHaveQuestions == true
										? ''
										: 'disableSharing'
								"
							/>

							<img
								v-if="roles.includes('PUT_TEST')"
								v-b-popover.hover.top="'Edit'"
								src="../../../assets/pencilicon.svg"
								@click.stop="
									!testDetails.isLocked
										? ((testModal = !testModal), copyingVal())
										: null
								"
								alt=""
								class="m-1"
								:class="testDetails.isLocked ? 'disableSharing' : ''"
							/>

							<img
								v-if="roles.includes('DELETE_TEST')"
								v-b-popover.hover.top="'Delete'"
								src="../../../assets/deleteicon.svg"
								@click.stop="
									!testDetails.isLocked ? (deleteModal = !deleteModal) : null
								"
								alt=""
								class="m-1"
								:class="testDetails.isLocked ? 'disableSharing' : ''"
							/>

							<img
								src="../../../assets/closeicon.svg"
								v-b-popover.hover.top="'Close'"
								alt=""
								class="m-1"
								@click.stop="$emit('test-card-option', null)"
							/>
						</div>
					</transition>
				</div>
			</div>
			<div
				class="ts-card-content"
				:class="testDetails.active ? 'pointer' : ''"
				style="margin: 20px 20px 0 20px;"
			>
				<div>
					<div class="mt-2">
						<span
							:class="
								testDetails.difficultyLevel == 'Easy'
									? 'pinktext'
									: testDetails.difficultyLevel == '--'
									? 'disabletext'
									: 'greytext'
							"
							>Easy / </span
						><span
							:class="
								testDetails.difficultyLevel == 'Medium'
									? 'pinktext'
									: testDetails.difficultyLevel == '--'
									? 'disabletext'
									: 'greytext'
							"
							>Medium </span
						><span
							:class="
								testDetails.difficultyLevel == 'Difficult'
									? 'pinktext'
									: testDetails.difficultyLevel == '--'
									? 'disabletext'
									: 'greytext'
							"
							>/ Difficult</span
						>
					</div>
				</div>
				<div>
					<div class="mt-2">
						<span
							:class="
								testDetails.autoCorrection == true ? 'pinktext' : 'greytext'
							"
							>Auto Corrected / </span
						><span
							:class="
								testDetails.autoCorrection == false ? 'pinktext' : 'greytext'
							"
						>
							Evaluated
						</span>
					</div>
				</div>
				<div class="mt-2">
					<span
						:class="testDetails.setPricing == false ? 'pinktext' : 'greytext'"
						>Free / </span
					><span
						:class="testDetails.setPricing == true ? 'pinktext' : 'greytext'"
					>
						Paid
						<span v-if="testDetails.setPricing == true"
							>(Rs.{{
								testDetails.setPricing == true ? testDetails.finalPrice : ""
							}})</span
						>
					</span>
				</div>
			</div>
			<div
				class="tp-cardv-submain d-flex justify-content-around mt-2 align-items-center"
				:class="testDetails.active ? 'pointer' : ''"
			>
				<div class="d-flex align-items-center flex-column">
					<span v-if="testDetails.numberOfSections < 10" class="greennumbertext"
						>0{{ testDetails.numberOfSections }}</span
					>
					<span v-else class="greennumbertext">{{
						testDetails.numberOfSections
					}}</span>
					<span class="tp-cardhead">Sections</span>
				</div>
				<div
					v-b-popover.hover.top="'Candidates taken test'"
					class="d-flex align-items-center flex-column"
				>
					<span v-if="testDetails.candidateCount < 10" class="bluenumbertext"
						>0{{ testDetails.candidateCount }}</span
					>
					<span v-else class="bluenumbertext">{{
						testDetails.candidateCount
					}}</span>
					<span class="tp-cardhead">Candidates</span>
				</div>
				<div class="d-flex align-items-center flex-column">
					<span v-if="testDetails.marks < 10" class="yellownumbertext"
						>0{{ testDetails.marks.toString().slice(0, 4) }}</span
					>
					<span v-else class="yellownumbertext">{{
						testDetails.marks.toString().slice(0, 7)
					}}</span>
					<span class="tp-cardhead">Marks</span>
				</div>
			</div>
			<div class="d-flex justify-content-center">
				<div
					class="inactive-text-box"
					v-if="!testDetails.active"
					:class="testConfigData.testID == testDetails.testID ? '' : ''"
				>
					<div class="inactive-txt">Inactive</div>
				</div>
			</div>
		</div>

		<template v-if="deleteModal">
			<DeleteTest
				:deleteModal="deleteModal"
				:testDetails="testDetails"
				:topicID="$route.params.topicID"
				@hide="deleteModal = false"
				:context="this"
				@resetPagination="$emit('resetPagination', showindex)"
				@cardClose="$emit('card-close', testDetails.testID)"
			/>
		</template>
		<template v-if="testModal">
			<EditTest
				:testModal="testModal"
				:roles="roles"
				:testDetails="testDetails"
				@hide="testModal = false"
				:topicID="$route.params.topicID"
				:context="this"
				@cardClose="$emit('card-close', testDetails.testID)"
				@resetSelTest="selTest = ''"
				@lengthofTotalTopicsWhenedidted="checkLog"
				@resetPagination="$emit('resetPagination')"
			/>
		</template>

		<template v-if="cloneTestModal">
			<CloneTest
				:cloneTestModal="cloneTestModal"
				@hide="cloneTestModal = false"
				:clone="testDetails"
				@cardClose="$emit('card-close', testDetails.testID)"
				:topicID="$route.params.topicID"
				:context="this"
				@resetPagination="$emit('resetPagination')"
			/>
		</template>

		<template v-if="locktestModal">
			<TestLock
				:locktestModal="locktestModal"
				@hide="locktestModal = false"
				:testDetails="testDetails"
				:topicID="$route.params.topicID"
				:context="this"
				@resetPagination="$emit('resetPagination')"
			/>
		</template>

		<template v-if="publicAvailabilityModal">
			<PublicAvailability
				:showModal="publicAvailabilityModal"
				:testDetails="testDetails"
				:topicID="$route.params.topicID"
				@hide="publicAvailabilityModal = false"
				@updated="onPublicAvailabilityUpdated"
			/>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import successToast from "../../mixin/toast.js";
import errorToast from "../../mixin/toast";
import DeleteTest from "../../../controllers/Test/modals/DeleteTest.vue";
import EditTest from "../../../controllers/Test/modals/EditTest.vue";
import CloneTest from "../../../controllers/Test/modals/CloneTest.vue";
import TestLock from "../../../controllers/Test/modals/TestLock.vue";
import PublicAvailability from "../../../controllers/Test/modals/PublicAvailability.vue";

import TestMixins from "../../../controllers/Test/TestMixins.js";

export default {
	name: "TestCard",
	mixins: [successToast, errorToast, TestMixins],
	props: {
		showindex: Number,
		selectFirstCard: Object,
		testDetails: Object,
		simp: Boolean,
		type: String,
		sort: Number,
		ttype: String,
		tsort: Number,
	},
	components: {
		DeleteTest,
		EditTest,
		CloneTest,
		TestLock,
		PublicAvailability,
	},
	data() {
		return {
			selTest: "",
			deleteModal: false,
			locktestModal: false,
			testModal: false,
			cloneTestModal: false,
			publicAvailabilityModal: false,
			showTestConfig: false,
			showPreviewTest: false,
			publicAvailability: false,
			config_status: true,
			clone: { ...this.testDetails },
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
		};
	},
	computed: {
		...mapGetters("testVUEX", {
			testConfigData: "getTestConfigData",
			showTestPreviewStatus: "getShowTestPreviewStatus",
			testConfigStatus: "getTestConfigStatus",
		}),
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
		...mapGetters("userVUEX", {
			leaderboardAdminAccess: "getleaderboardAdminAccess",
		}),
		...mapGetters(["roles"]),
	},
	created() {
		if (this.showPreviewTest) {
			this.$store.commit("testVUEX/saveshowPreviewTest", {
				preview_status: false,
			});
		}
		this.testDetails["activecard"] = false;
		this.config_status = true;
	},
	methods: {
		checkLog() {
			this.$emit("lengthofTotalTopicsWhenedidted", this.showindex, this.clone);
		},
		goToShare() {
			console.log("came");

			if (
				this.roles.includes("GET_TEST_INDIVIDUAL") ||
				this.roles.includes("GET_TEST_GROUP")
			) {
				console.log("hicame");
				this.$router.push({
					path: `/sharewithpeople/${this.$route.params.topicID}/${this.testDetails.testID}`,
					query: {
						type: this.type,
						sort: this.sort,
						ttype: this.ttype,
						tsort: this.tsort,
						tfrom: "testcard",
					},
				});
				this.$store.commit("testVUEX/saveSelectedTest", this.testDetails.name);
			}
		},
		copyingVal() {
			this.selTest = this.testDetails.testID;
			this.clone = { ...this.testDetails };
		},
		onPublicAvailabilityUpdated(data) {
			this.testDetails.publicAvailability = data.publicAvailability;
			if ("setPricing" in data) this.testDetails.setPricing = data.setPricing;
			if ("leaderboard" in data)
				this.testDetails.leaderboard = data.leaderboard;
			if ("leaderboardCategory" in data)
				this.testDetails.leaderboardCategory = data.leaderboardCategory;
			this.$emit("resetPagination");
		},
	},
};
</script>

<style scoped>
.inc-border {
	border-radius: 8px !important;
	width: 299px !important;
}
.inactive-text-box {
	background: #ffeeee;
	border-radius: 3px;
	padding: 5px;
	position: absolute;
	bottom: 3px;

	width: 272px;
	text-align: center;
}
.clonetestname {
	margin-top: 15px;
	width: 100%;
	height: 37px;
	background: #f5f5f5;
}

.inactive-txt {
	font-weight: 400;
	font-size: 12px;
	color: #ad1927;
}

.relativeclass {
	position: relative;
}

.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	width: 302px;
	height: 221px;
	border-radius: 8px;
	padding: 15px;
}

.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(10px);
	opacity: 0;
}
.hidebutton.btn-secondary {
	background-color: #fff !important;
	color: black !important;
	border: none;
}
.clonetest-name-validation-icon {
	padding-right: 7px;
	padding-left: 5px;
	position: absolute;
	top: 5px;
	right: 3px;
	background: rgb(255, 255, 255);
}
</style>
